/**
 * NetworkSetting entity class
 */

/**
 * NetworkSettingFactory
 * returns NetworkSetting entity class
 *
 * @class NetworkSettingFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.NetworkSetting} class
 *
 * @ngdoc factory
 * @name mwApp.factory:NetworkSettingFactory
 */
/* @ngInject */
export default function NetworkSettingFactory (Setting) {
  /* === NetworkSetting class === */

  /**
   * NetworkSetting model
   *
   * @class NetworkSetting
   * @classdesc NetworkSetting model
   * @memberof models
   * @see models
   * @extends models.Setting
   * @param {Object} [object] - initial object, containing NetworkSetting entity fields
   * @return {models.NetworkSetting} NetworkSetting entity
   */
  function NetworkSetting () {
    var obj = Setting.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  NetworkSetting.prototype = Object.create(Setting.prototype)
  NetworkSetting.prototype.constructor = NetworkSetting

  /* === NetworkSetting instance methods & fields === */

  Object.assign(NetworkSetting.prototype, {

    /**
     * url template
     *
     * @memberof models.NetworkSetting#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{network.id}}/settings'

  })

  /* === NetworkSetting static methods & fields === */

  // copy all static methods from Setting class
  Object.assign(NetworkSetting, Setting)
  NetworkSetting._name = 'NetworkSetting'
  NetworkSetting.init()

  return NetworkSetting
}
